﻿import window from 'window';

import { loadModules } from './foundation/moduleInitializer';

import { offerGlider } from './feature/page-content/offerGlider';
import { infoGlider } from './feature/page-content/infoGlider';

import { journeySelector } from './feature/search/journeySelector';
import { journeySelectorBlock } from './feature/search/journeySelectorBlock';

const app = (() => {

    const modules = [ 
        offerGlider,
        infoGlider,
        journeySelectorBlock,
        journeySelector,
    ];
    
    return {
        init() {
            loadModules(modules);
        }
    };
})();

window.addEventListener('DOMContentLoaded', app.init);